const { REACT_APP_RULES_URL: RULES, REACT_APP_AGREEMENTS_URL: AGREEMENTS } = process.env

export const formLocale = {
  succsess: {},

  badRequest: {},

  serverError: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },

  notValid: {
    warning: [
      `Внимание! Одно или несколько полей не заполнены или заполнены неверно.
		 	<br/>Проверьте корректность заполнения полей.`,
    ],
  },

  signin: {
    invalidCredentials: { error: ['Неверный логин или пароль.'] },
  },

  rulesCheckbox: (
    <span>
      Я согласен с{' '}
      <a href={RULES} style={{ color: '#ffffff', whiteSpace: 'nowrap' }} target="_blank" rel="noreferrer">
        PRO Правилами мероприятия
      </a>{' '}
      и{' '}
      <a href={AGREEMENTS} style={{ color: '#ffffff', whiteSpace: 'nowrap' }} target="_blank" rel="noreferrer">
        Пользовательским соглашением
      </a>
    </span>
  ),

  subscribeSmsCheckbox: <span>Согласен на получение sms рассылки</span>,

  subscribeEmailCheckbox: (
    <span>
      Я согласен получать информацию о мероприятии по <span style={{ whiteSpace: 'nowrap' }}>e-mail</span>
    </span>
  ),
}
